import React from "react";
import { useAuth } from "../contexts/AuthContext";
import back from "../assets/icons/9.png"
import {
  MessageOutlined as MessageOutlinedIcon,
  CameraAltOutlined as CameraAltOutlinedIcon,
  EditNoteOutlined as EditNoteOutlinedIcon,
  Person2Outlined as Person2OutlinedIcon,
  ChevronRight as ChevronRightIcon,
} from "@mui/icons-material";
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import BottomNavigation from "../components/bottom_navigation";
const { useNavigate } = require("react-router-dom");


export default function HealthAssistant() {


    const { profile } = useAuth();
    const navigate = useNavigate();
    return (
      <div
        style={{
          minHeight: "100vh",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          background: "var(--bg)",
          fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, sans-serif",
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: 420,
            padding: 20,
            boxSizing: "border-box",
          }}
        >
          {/* Header - Consistent with other pages */}
          <BottomNavigation/>
          <div style={{ marginBottom: 18 }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <i
                  className="fi fi-br-angle-left"
                  onClick={() => navigate(-1)}
                  style={{
                    cursor: 'pointer',
                    padding: '8px',
                    borderRadius: '50%',
                    color: "black",
                    background: "#f7f4ff",
                    fontSize: '20px',
                  }}
                ></i>
                <span style={{ fontWeight: 700, fontSize: 20, color: "#2d176a", letterSpacing: 0.2 }}>Health Assistant</span>
              </div>
              <div
                style={{
                  width: 36,
                  height: 36,
                  borderRadius: "50%",
                  overflow: "hidden",
                  background: "var(--surface)",
                  boxShadow: "0 4px 10px rgba(0,0,0,0.12)",
                  flexShrink: 0,
                  cursor: "pointer",
                  border: "2px solid #ece5ff"
                }}
                onClick={() => { navigate("/profile") }}
              >
                <img
                  src={profile?.avatar || "/avatar.png"}
                  alt="Profile"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </div>
            </div>
            <div style={{ fontSize: 13, color: "#7c6ca7", marginTop: 2, marginLeft: 2, fontWeight: 500 }}>
              Get instant answers to your health questions
            </div>
          </div>

          {/* Hero Card Section (from image) */}
          <div
            style={{
              width: "100%",
              borderRadius: 16,
              background: "linear-gradient(135deg, #F8F5FF 0%, #EEE6FF 50%, #F5F0FF 100%)",
              boxShadow: "0 4px 16px rgba(123,79,255,0.10)",
              border: "1px solid rgba(123,79,255,0.10)",
              padding: "18px 12px 16px 14px",
              marginBottom: 18,
              position: "relative",
              overflow: "hidden"
            }}
          >
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 10 }}>
              {/* Left Text */}
              <div style={{ flex: 1, minWidth: 100 }}>
                <div style={{ fontSize: 18, fontWeight: 800, color: "#1E1B39", marginBottom: 6, lineHeight: 1.18 }}>
                  Welcome to Your <span style={{ color: "#7B4FFF" }}>AI Health</span> Assistant
                </div>
                <div style={{ fontSize: 11, color: "#5B5B6B", marginBottom: 10, maxWidth: 210, lineHeight: 1.4 }}>
                  Get instant answers to your health questions, analyze symptoms, and manage your medical information securely.
                </div>
              </div>
              {/* Right Robot */}
                 <div
            style={{
              width: 88,
              height: 88,
              borderRadius: "50%",
              margin: "0 auto 16px",
              background : "var(--primary)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <svg
        viewBox="0 0 512 512"
        width="48"
        height="48"
        color = "white"
      >
        <path
          d="m256 16c-10.7 220.5-19.5 229.3-240 240 220.5 10.7 229.3 19.5 240 240 10.7-220.5 19.5-229.3 240-240-220.5-10.7-229.3-19.5-240-240z"
          fill="currentColor"
        />
      </svg>
          </div>
            </div>
            {/* Features Row */}
            <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", gap: 14, marginTop: 10, flexWrap: "wrap" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                <i className="fi fi-rr-shield-check" style={{ color: "#7B4FFF", fontSize: 13 }}></i>
                <span style={{ fontSize: 10, color: "#1E1B39", fontWeight: 600 }}>Private & Secure</span>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                <AutoAwesomeIcon style={{ color: "#7B4FFF", fontSize: 13 }} />
                <span style={{ fontSize: 10, color: "#1E1B39", fontWeight: 600 }}>AI-Powered</span>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                <i className="fi fi-rr-user-check" style={{ color: "#7B4FFF", fontSize: 13 }}></i>
                <span style={{ fontSize: 10, color: "#1E1B39", fontWeight: 600 }}>Verified Guidance</span>
              </div>
            </div>
          </div>

   

        {/* Cards */}
<div
  style={{
    minHeight: "100vh",
    

  }}
>
  <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
    {[
      {
        icon: <MessageOutlinedIcon />,
        title: "Ask Health Questions",
        subtitle: "Get instant AI-powered health guidance",
        tag: "Start here",
        iconBg: "#F1ECFF",
        tagBg: "#F6EDFF",
        path: "/asha",
      },
      {
        icon: <CameraAltOutlinedIcon />,
        title: "Photo Analysis",
        subtitle: "Upload photos of skin, wounds or rashes",
        tag: "Photo analysis",
        iconBg: "#FFF0D9",
        tagBg: "#FFF3E6",
        path: "/photo-analysis",
      },
      {
        icon: <EditNoteOutlinedIcon />,
        title: "Lab Reports",
        subtitle: "Upload and analyze medical test results",
        tag: "Upload & analyze",
        iconBg: "#EAF6FF",
        tagBg: "#EEF7FF",
        path: "/lab-tests",
      },
      {
        icon: <Person2OutlinedIcon />,
        title: "My Health Profile",
        subtitle: "Manage and store your health records securely",
        tag: "Secure storage",
        iconBg: "#F6E9FF",
        tagBg: "#F7EDFF",
        path: "/profile",
      },
    ].map((item, index) => (
      <div
        key={index}
        onClick={() => navigate(item.path)}
        style={{
          background: "rgba(255,255,255,0.94)",
          borderRadius: 22,
          padding: "10px 8px",
          display: "flex",
          alignItems: "center",
          gap: 16,
          border: "1px solid rgba(180,140,255,0.35)",
          boxShadow: "0 12px 28px rgba(0,0,0,0.08)",
          cursor: "pointer",
        }}
      >
        {/* Icon */}
        <div
          style={{
            width: 48,
            height: 48,
            borderRadius: 14,
            backgroundColor: item.iconBg,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transform: "translateY(-1px)",
            flexShrink: 0,
          }}
        >
          {item.icon}
        </div>

        {/* Text */}
        <div style={{ flex: 1 }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: 6,
            }}
          >
            <div
              style={{
                fontSize: 13,
                fontWeight: 550,
                letterSpacing: "0.1px",
              }}
            >
              {item.title}
            </div>

            <div
              style={{
                fontSize: 12,
                padding: "6px 12px",
                borderRadius: 999,
                background: item.tagBg,
                color: "#6F3DFF",
                fontWeight: 500,
                backdropFilter: "blur(4px)",
                whiteSpace: "nowrap",
                // position : "absolute",
                // left : "50%"
              }}
            >
              {item.tag}
            </div>
          </div>

          <div
            style={{
              fontSize: 11,
              color: "#6F6F6F",
              lineHeight: "1.45",
              maxWidth: 220,
            }}
          >
            {item.subtitle}
          </div>
        </div>

        {/* Chevron */}
        <ChevronRightIcon
          style={{
            fontSize: 20,
            color: "#8E8E8E",
            marginTop: -10,
          }}
        />
      </div>
    ))}
  </div>



  {/* Health Data Protection Banner */}
  <div style={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    background: 'linear-gradient(90deg, #F8F5FF 0%, #EEE6FF 100%)',
    borderRadius: 16,
    padding: '18px 18px 18px 20px',
    marginTop: 32,
    marginBottom: 18,
    boxShadow: '0 2px 8px rgba(123,79,255,0.07)',
    border: '1px solid #E6DFFF',
    minHeight: 64
  }}>
    <div style={{ flex: 1 }}>
      <div style={{ fontWeight: 700, fontSize: 15, color: '#2d176a', marginBottom: 2 }}>
        Your health data is protected
      </div>
      <div style={{ fontSize: 12, color: '#7c6ca7', fontWeight: 500 }}>
        We use bank-level encryption to keep your information safe and private.
      </div>
    </div>
    <div style={{ marginLeft: 18, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{
        width: 48,
        height: 48,
        borderRadius: '50%',
        background: '#f7f4ff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1.5px solid #e6dfff',
      }}>
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="28" height="28" rx="8" fill="#7B4FFF" fillOpacity="0.12"/>
          <path d="M14 8C11.2386 8 9 10.2386 9 13V15C9 17.7614 11.2386 20 14 20C16.7614 20 19 17.7614 19 15V13C19 10.2386 16.7614 8 14 8Z" stroke="#7B4FFF" strokeWidth="1.5"/>
          <path d="M14 12V15" stroke="#7B4FFF" strokeWidth="1.5" strokeLinecap="round"/>
          <circle cx="14" cy="17" r="1" fill="#7B4FFF"/>
        </svg>
      </div>
    </div>
  </div>

  {/* QuickRescue Urgent Help Section */}
  <div style={{
    background: '#fff',
    borderRadius: 16,
    padding: '18px 18px 18px 20px',
    boxShadow: '0 2px 8px rgba(255,0,0,0.04)',
    border: '1px solid #FFE6E6',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 8
  }}>
    <div style={{ flex: 1 }}>
      <div style={{ color: '#E53935', fontWeight: 700, fontSize: 15, marginBottom: 2 }}>
        Need urgent help?
      </div>
      <div style={{ fontSize: 12, color: '#7c6ca7', fontWeight: 500 }}>
        For emergencies, use <a href="/emergency-response" onClick={(e) => { e.preventDefault(); navigate('/emergency-response'); }} style={{ color: '#7B4FFF', textDecoration: 'underline', fontWeight: 600 }}>QuickRescue</a>
      </div>
    </div>
    <button
      style={{
        background: '#FFE6E6',
        color: '#E53935',
        border: 'none',
        borderRadius: 12,
        padding: '10px 18px',
        fontWeight: 700,
        fontSize: 15,
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        cursor: 'pointer',
        boxShadow: '0 2px 8px rgba(229,57,53,0.07)'
      }}
      onClick={() => navigate('/emergency-response')}
    >
      <span style={{ display: 'flex', alignItems: 'center' }}>
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: 6 }}>
          <rect width="18" height="18" rx="4" fill="#E53935" fillOpacity="0.12"/>
          <path d="M9 5V13" stroke="#E53935" strokeWidth="1.5" strokeLinecap="round"/>
          <path d="M5 9H13" stroke="#E53935" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
        QuickRescue
      </span>
    </button>
  </div>
</div>


      </div>
    </div>
  );
}
